import {
  View,
  Text,
  Image,
  TouchableOpacity,
  ScrollView,
  ActivityIndicator,
  KeyboardAvoidingView,
  Platform,
} from "react-native";
import { LinearGradient } from "expo-linear-gradient";
import React, { useEffect, useState } from "react";
import { useLocalSearchParams } from "expo-router";
import i18n from "../../../locales/i18n";
import FloatingLabelInput from "../../../components/FloatingLabelInput";
import Animated, { FadeInDown, ZoomIn } from "react-native-reanimated";
import MaterialIcons from "@expo/vector-icons/MaterialIcons";
import customAxios from "../../../utils/customAxios";
import { router } from "expo-router";
import DeptHeaderIcon from "../../../assets/dept/dept.svg";
import { Toast } from "react-native-toast-notifications";
import StandardNavigation from "../../../components/navigation/StandardNavigation";
import Bill from "../../../components/stats/Bill";
import WebDetteDetailsScreen from "../../../components/web/WebDetteDetailsScreen";

const index = () => {
  // Return web version for web platform
  if (Platform.OS === "web") {
    return <WebDetteDetailsScreen />;
  }
  const [name, setName] = useState("");
  const [Amount, setAmount] = useState("");
  const [buttunSpinner, setButtonSpinner] = useState(false);
  const [phone, setPhone] = useState("");
  const [edit, setedit] = useState(false); // For editing basic info (name, amount, phone)
  const [paymentEdit, setPaymentEdit] = useState(false); // For payment editing
  const [editPaidAmount, setEditPaidAmount] = useState(""); // For editing the paid amount directly
  const [originalData, setOriginalData] = useState({
    name: "",
    amount: "",
    phone: "",
    paidamount: 0,
  });
  const [extractedValue, setExtractedValue] = useState("");
  const [bill, setBill] = useState<any>(null);
  const [buttonSpinnerDelete, setButtonSpinnerDelete] = useState(false);
  const [created_at, setcreated_at] = useState("");
  const [paidAmount, setPaidAmount] = useState(0); // Track paid amount
  const { id } = useLocalSearchParams();
  const locale = i18n.locale;

  // Calculate remaining debt and payment status
  const totalAmount = parseFloat(Amount) || 0;
  const remainingAmount = totalAmount - paidAmount;
  const paymentPercentage =
    totalAmount > 0 ? (paidAmount / totalAmount) * 100 : 0;

  // Determine status
  const getPaymentStatus = () => {
    if (remainingAmount <= 0) return "paid";
    if (paidAmount > 0) return "partial";
    return "unpaid";
  };

  const getStatusColor = () => {
    const status = getPaymentStatus();
    switch (status) {
      case "paid":
        return "#22C55E"; // Green
      case "partial":
        return "#F59E0B"; // Orange
      case "unpaid":
        return "#EF4444"; // Red
      default:
        return "#6B7280"; // Gray
    }
  };

  useEffect(() => {
    let isMounted = true; // Add a flag to track if the component is mounted
    const handelGetDept = async () => {
      try {
        //  setButtonSpinner(true);
        const res = await customAxios.get(`/debt/${id}`, {
          withCredentials: true,
        });
        const debtData = res?.data;

        // Safely set values with fallbacks
        setName(debtData?.fullname || "");
        setAmount(debtData?.amount?.toString() || "0");
        setBill(debtData?.Facture || null);
        setPhone(debtData?.phone || "");
        setcreated_at(debtData?.createdAt || "");

        const paidAmountValue = Number(debtData?.paidamount) || 0;
        setPaidAmount(paidAmountValue);
        setEditPaidAmount(paidAmountValue.toString());

        // Store original data for reset functionality
        setOriginalData({
          name: debtData?.fullname || "",
          amount: debtData?.amount?.toString() || "0",
          phone: debtData?.phone || "",
          paidamount: paidAmountValue,
        });
        if (isMounted) {
          //  setButtonSpinner(false);
          //  setdatas(res?.data);
        }
      } catch (error) {
        if (isMounted) {
          //  setButtonSpinner(false);
          Toast.show(
            i18n.t("errorwhilefetchingdette") || "Error loading debt details",
            {
              type: "danger",
            }
          );
          router.back();
        }
      }
    };

    handelGetDept();

    return () => {
      isMounted = false; // Cleanup function to set isMounted to false
    };
  }, []); // Add `datas` to the dependency array

  const handelConfirm = async () => {
    if (extractedValue !== "") {
      setButtonSpinner(true);
      try {
        setButtonSpinner(true);
        const res = await customAxios.patch(`/debt/pay/${id}`, {
          paidamount: Number(extractedValue),
        });

        // Update paid amount locally
        const newTotalPaid = paidAmount + Number(extractedValue);
        setPaidAmount(newTotalPaid);
        setEditPaidAmount(newTotalPaid.toString());

        // Update original data to reflect the new paid amount
        setOriginalData((prev) => ({
          ...prev,
          paidamount: newTotalPaid,
        }));

        Toast.show(i18n.t("dettehasbeenpaid"), {
          type: "success",
        });

        // Don't navigate away, just update the UI
        // router.push("/dettes");
      } catch (error) {
        Toast.show(i18n.t("errorwhilepaying"), {
          type: "danger",
        });
      } finally {
        setButtonSpinner(false);
        setPaymentEdit(false);
        setExtractedValue("");
      }
    }
  };

  const handleEditToggle = () => {
    if (edit) {
      // If currently in edit mode, save the changes
      handleUpdateDebt();
    } else {
      // If not in edit mode, enable editing
      setedit(true);
    }
  };

  const handleUpdateDebt = async () => {
    try {
      setButtonSpinner(true);

      // Validate inputs
      if (!name.trim()) {
        Toast.show(i18n.t("fillall"), { type: "danger" });
        return;
      }

      if (!Amount || Number(Amount) <= 0) {
        Toast.show(i18n.t("validevalueerror"), { type: "danger" });
        return;
      }

      // Phone validation for Algerian numbers (10 digits exactly)
      if (phone && !/^\d{10}$/.test(phone.replace(/[\s-]/g, ""))) {
        Toast.show(i18n.t("invalidPhoneNumber"), { type: "danger" });
        return;
      }

      const updateData = {
        fullname: name.trim(),
        amount: Number(Amount),
        phone: phone.trim(),
        paidamount: Number(editPaidAmount) || 0,
      };

      const res = await customAxios.patch(`/debt/edit/${id}`, updateData);

      Toast.show(i18n.t("updateSuccess"), {
        type: "success",
      });

      // Update local paid amount state
      setPaidAmount(Number(editPaidAmount) || 0);

      // Update original data with new values
      setOriginalData({
        name: name,
        amount: Amount,
        phone: phone,
        paidamount: Number(editPaidAmount) || 0,
      });

      // Exit edit mode
      setedit(false);
    } catch (error) {
      Toast.show(i18n.t("updateFailed"), {
        type: "danger",
      });
    } finally {
      setButtonSpinner(false);
    }
  };

  const handleCancelEdit = () => {
    // Reset to original values
    setName(originalData.name);
    setAmount(originalData.amount);
    setPhone(originalData.phone);
    setEditPaidAmount(originalData.paidamount.toString());
    setedit(false);
  };

  const handelDelete = async () => {
    try {
      setButtonSpinnerDelete(true);
      const res = await customAxios.delete(`/debt/${id}`);

      Toast.show(i18n.t("dettehasbeendeleted"), {
        type: "success",
      });
      router.push("/dettes");
    } catch (error) {
      Toast.show(i18n.t("errorwhilepaying"), {
        type: "danger",
      });
    } finally {
      setButtonSpinnerDelete(false);
    }
  };

  return (
    <View style={{ flex: 1, backgroundColor: "#f5f5f5" }}>
      {/* Standard Navigation */}
      <StandardNavigation
        title={name}
        showBackButton={true}
        showMenuButton={true}
        icon={<DeptHeaderIcon width={30} height={30} />}
        showLogo={true}
      />

      <KeyboardAvoidingView
        behavior={Platform.OS === "ios" ? "padding" : "height"}
        style={{ flex: 1 }}
        keyboardVerticalOffset={Platform.OS === "ios" ? 0 : 20}
      >
        <ScrollView className="flex-1" style={{ backgroundColor: "#f5f5f5" }}>
          <Animated.View
            entering={ZoomIn.delay(50).duration(500)}
            className={`
           justify-center flex-1   items-center  gap-x-4   mt-4 `}
          >
            <FloatingLabelInput
              label={i18n.t("nameofdain")}
              value={name}
              onChangeText={setName}
              locale={locale}
              keyboardType="default"
              editable={edit}
            />

            <FloatingLabelInput
              label={i18n.t("quantityofdette")}
              value={Amount.toString()}
              onChangeText={setAmount}
              locale={locale}
              keyboardType="numeric"
              editable={edit}
            />

            <FloatingLabelInput
              label={i18n.t("phonenumber")}
              value={phone}
              onChangeText={setPhone}
              locale={locale}
              keyboardType="phone-pad"
              editable={edit}
            />

            {edit && (
              <FloatingLabelInput
                label={i18n.t("paidamount")}
                value={editPaidAmount}
                onChangeText={setEditPaidAmount}
                locale={locale}
                keyboardType="numeric"
                editable={true}
              />
            )}

            {/* Payment Status Section */}
            <Animated.View
              entering={FadeInDown.delay(150).duration(500)}
              style={{
                width: "85%",
                backgroundColor: "white",
                borderRadius: 15,
                padding: 20,
                marginVertical: 15,
                shadowColor: "#000",
                shadowOffset: { width: 0, height: 2 },
                shadowOpacity: 0.1,
                shadowRadius: 4,
                elevation: 3,
                borderLeftWidth: 5,
                borderLeftColor: getStatusColor(),
                marginTop: 80,
              }}
            >
              <Text
                style={{
                  fontSize: 18,
                  fontWeight: "bold",
                  textAlign: "center",
                  marginBottom: 15,
                  color: "#374151",
                }}
              >
                {i18n.t("paymentStatus")}
              </Text>

              <View
                style={{
                  flexDirection: locale === "ar" ? "row-reverse" : "row",
                  justifyContent: "space-between",
                  marginBottom: 10,
                }}
              >
                <Text style={{ fontSize: 16, color: "#6B7280" }}>
                  {i18n.t("total")}:
                </Text>
                <Text
                  style={{ fontSize: 16, fontWeight: "bold", color: "#374151" }}
                >
                  {totalAmount} {i18n.t("currency")}
                </Text>
              </View>

              <View
                style={{
                  flexDirection: locale === "ar" ? "row-reverse" : "row",
                  justifyContent: "space-between",
                  marginBottom: 10,
                }}
              >
                <Text style={{ fontSize: 16, color: "#6B7280" }}>
                  {i18n.t("paidamount")}:
                </Text>
                <Text
                  style={{
                    fontSize: 16,
                    fontWeight: "bold",
                    color: getStatusColor(),
                  }}
                >
                  {paidAmount} {i18n.t("currency")}
                </Text>
              </View>

              <View
                style={{
                  flexDirection: locale === "ar" ? "row-reverse" : "row",
                  justifyContent: "space-between",
                  marginBottom: 15,
                }}
              >
                <Text style={{ fontSize: 16, color: "#6B7280" }}>
                  {i18n.t("remaining")}:
                </Text>
                <Text
                  style={{
                    fontSize: 16,
                    fontWeight: "bold",
                    color: remainingAmount > 0 ? "#EF4444" : "#22C55E",
                  }}
                >
                  {remainingAmount} {i18n.t("currency")}
                </Text>
              </View>

              {/* Progress Bar */}
              <View
                style={{
                  height: 8,
                  backgroundColor: "#E5E7EB",
                  borderRadius: 4,
                  overflow: "hidden",
                  marginBottom: 10,
                }}
              >
                <View
                  style={{
                    height: "100%",
                    width: `${Math.min(paymentPercentage, 100)}%`,
                    backgroundColor: getStatusColor(),
                    borderRadius: 4,
                  }}
                />
              </View>

              <Text
                style={{
                  textAlign: "center",
                  fontSize: 14,
                  color: getStatusColor(),
                  fontWeight: "600",
                }}
              >
                {paymentPercentage.toFixed(1)}% {i18n.t("paid")}
              </Text>
            </Animated.View>

            <Animated.View
              entering={FadeInDown.delay(50).duration(500)}
              className={`${
                locale == "ar" ? "  " : ""
              }       w-full flex-row    my-4 justify-between `}
              style={{
                width: "85%",
              }}
            >
              {/* Edit/Update Info Button */}
              <TouchableOpacity
                onPress={handleEditToggle}
                style={{ borderRadius: 9999 }}
              >
                <LinearGradient
                  colors={
                    edit
                      ? ["rgba(34, 197, 94, 1)", "rgba(22, 163, 74, 1)"] // Green for update
                      : ["rgba(19, 121, 162, 1)", "rgba(5, 150, 208, 1)"] // Blue for edit
                  }
                  style={{
                    flexDirection: locale == "fr" ? "row" : "row-reverse",
                    borderRadius: 9999,
                    gap: 8,
                    paddingHorizontal: 12,
                    paddingVertical: 8,
                  }}
                >
                  {buttunSpinner ? (
                    <ActivityIndicator size="small" color="white" />
                  ) : (
                    <>
                      <Text className="text-white text-base font-bold">
                        {edit ? i18n.t("updatdette") : i18n.t("editdain")}
                      </Text>
                      <MaterialIcons
                        name={edit ? "save" : "edit"}
                        size={20}
                        color="white"
                      />
                    </>
                  )}
                </LinearGradient>
              </TouchableOpacity>

              {/* Cancel Edit or Payment/Delete Button */}
              {edit ? (
                <TouchableOpacity
                  onPress={handleCancelEdit}
                  className={`${
                    locale == "fr" ? "  flex-row  " : "  flex-row-reverse "
                  }  rounded-full  bg-gray-500 gap-2 px-3 py-2    `}
                >
                  <Text className="text-white text-base font-bold">
                    {i18n.t("cancel")}
                  </Text>
                  <MaterialIcons name="close" size={20} color="white" />
                </TouchableOpacity>
              ) : (
                <TouchableOpacity
                  onPress={handelDelete}
                  className={`${
                    locale == "fr" ? "  flex-row  " : "  flex-row-reverse "
                  }  rounded-full  bg-red-500 gap-2 px-3 py-2    `}
                >
                  {buttonSpinnerDelete ? (
                    <ActivityIndicator size="small" color="white" />
                  ) : (
                    <>
                      <Text className="text-white text-base font-bold">
                        {i18n.t("deletedette")}
                      </Text>
                      <MaterialIcons name="delete" size={20} color="white" />
                    </>
                  )}
                </TouchableOpacity>
              )}
            </Animated.View>

            {/* Payment Section - Only show when not editing basic info */}
            {!edit && (
              <Animated.View
                entering={FadeInDown.delay(100).duration(500)}
                className={`${
                  locale == "ar" ? "  " : ""
                }       w-full flex-row    my-4 justify-center `}
                style={{
                  width: "85%",
                }}
              >
                <TouchableOpacity
                  onPress={() => setPaymentEdit((prev) => !prev)}
                  className={`${
                    locale == "fr" ? "  flex-row  " : "  flex-row-reverse "
                  }  rounded-full gap-4 px-4 py-2 ${
                    paymentEdit ? "bg-yellow-500" : "bg-green-500"
                  }`}
                >
                  <Text className="text-white text-xl font-bold">
                    {paymentEdit ? i18n.t("cancel") : i18n.t("paidamount")}
                  </Text>
                  <MaterialIcons
                    name={paymentEdit ? "close" : "payment"}
                    size={24}
                    color="white"
                  />
                </TouchableOpacity>
              </Animated.View>
            )}

            {paymentEdit && (
              <FloatingLabelInput
                label={i18n.t("paidamount")}
                value={extractedValue}
                onChangeText={setExtractedValue}
                locale={locale}
                keyboardType="numeric"
              />
            )}
            {paymentEdit && (
              <Animated.View
                entering={FadeInDown.delay(50).duration(500)}
                className={`${
                  locale == "ar" ? " " : " "
                }       w-full flex     items-center justify-center `}
                style={{
                  width: "85%",
                }}
              >
                <TouchableOpacity
                  onPress={handelConfirm}
                  style={{
                    width: "100%",
                    borderRadius: 9999,
                  }}
                >
                  <LinearGradient
                    colors={["rgba(19, 121, 162, 1)", "rgba(5, 150, 208, 1)"]}
                    style={{
                      flexDirection: locale == "fr" ? "row" : "row-reverse",
                      borderRadius: 9999,
                      marginTop: 15,
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 16,
                      paddingHorizontal: 16,
                      paddingVertical: 8,
                    }}
                  >
                    {buttunSpinner ? (
                      <ActivityIndicator size="large" color="white" />
                    ) : (
                      <Text className="text-white text-2xl font-bold">
                        {i18n.t("confirm")}
                      </Text>
                    )}
                  </LinearGradient>
                </TouchableOpacity>
              </Animated.View>
            )}

            {/* Bill/Invoice Section */}
            {bill && bill.listofproducts && bill.listofproducts.length > 0 && (
              <Animated.View
                entering={FadeInDown.delay(50).duration(500)}
                style={{
                  width: "100%",
                  paddingHorizontal: 16,
                  marginTop: 30,
                  marginBottom: 30,
                }}
              >
                <Text
                  style={{
                    fontSize: 18,
                    fontWeight: "bold",
                    marginBottom: 15,
                    color: "#374151",
                    textAlign: locale === "ar" ? "right" : "left",
                    paddingHorizontal: 4,
                  }}
                >
                  {i18n.t("invoice")} {i18n.t("details")}
                </Text>
                <Bill
                  info={bill}
                  printed={false}
                  total={Amount}
                  created_at={created_at}
                />
              </Animated.View>
            )}
          </Animated.View>

          {/* Bottom Padding for Better Scrolling */}
          <View style={{ height: 50 }} />
        </ScrollView>
      </KeyboardAvoidingView>
    </View>
  );
};

export default index;
